import type { ConfettiShape } from '@/components/common/ConfettiAnimation/types';

// Text animation timing
export const TEXT_ANIMATION = {
  FIRST_LINE_DELAY: 10,
  FRAMES_PER_WORD: 6, // frames between each word fade-in start
  WORD_FADE_DURATION: 20, // fade duration for normal words
  WORD_FADE_DURATION_SLOW: 45, // fade duration for "Thank you" (last line)
  LINE_OVERLAP_OFFSET: 8, // next line starts when prev line's last word is ~40% through fade
  HIGHLIGHT_DELAY: 15, // delay after text appears before highlight animates
  HIGHLIGHT_DURATION: 15,
} as const;

// Curved lines (same as Scene5a but without animation)
export const CURVED_LINES_PATH =
  'M-244.346 922.769 C-46.974 624.508 228.513 740.319 405.375 882.55 C516.986 972.305 750.398 1126.38 1051.32 1036.27 C1366.21 941.982 1405.2 539.185 1814.35 592.521 C2223.49 645.858 2391.14 440.743 2307.27 351.539 C2223.39 262.335 1937.57 484.335 1558.05 490.114 C1178.54 495.893 957.617 -62.3497 239.434 357.675 C125.456 431.162 -137.975 550.693 -354.633 427.215 C-626.937 272.023 -757.869 208.658 -1185.43 338.602';

// Confetti configuration for Scene 8
export const CONFETTI_CONFIG_SCENE8 = {
  PARTICLES_PER_BURST: 150,
  ANGLE: 90,
  SPREAD: 120,
  TICKS: 500,
  GRAVITY: 1.5,
  SCALAR: 1.5,
  DRIFT: 0.3,
  START_VELOCITY: 60,
  DECAY: 0.92,
  SHAPES: ['square'] as ConfettiShape[],
  Z_INDEX: 100,
  BURST_LOCATIONS: [
    { x: 0.5, ratio: 1.0 },
    { x: 0.2, ratio: 0.7 },
    { x: 0.8, ratio: 0.7 },
    { x: 0.05, ratio: 0.4 },
    { x: 0.95, ratio: 0.4 },
  ],
} as const;

export const TEXT_CONTENT =
  'Your \\dedication\\ and\n\\effort\\ made this\nyear successful.\nThank you!';

export const SIDE_LINE_DURATION = 70;
export const LAST_LINE_EXTRA_DELAY = 15; // 0.5s pause before "Thank you!" at 30fps

export const SHIMMER_DURATION = 20;
export const SHIMMER_DELAY_AFTER_HIGHLIGHT = 5;

// Word fade-in animation settings
export const WORD_FADE_DURATION = 60;
export const WORD_FADE_DURATION_SLOW = 140;
export const WORD_SLIDE_DISTANCE = 0;

// Fraction of word fade duration after which the highlight box starts appearing.
export const HIGHLIGHT_TRIGGER_FRACTION = 0;
